var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('drawer',{attrs:{"dismissRoute":'/user/address_book/'}},[_c('div',{staticClass:"drawer-title"},[_c('i',{staticClass:"mat-icon"},[_vm._v("add_circle")]),_vm._v("New Address"),_c('address-builder',{attrs:{"displaySave":true,"loading":_vm.loading,"has-notes":false},on:{"saveClick":_vm.createAddress}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04b64213","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/user/AddressesNew.vue
// module id = 640
// module chunks = 0